import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../store';
import {selectSolarLuminarCountValue} from '../solarSelectors';

@customElement('solar-recommendations')
export class solarRecommendations extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			flex-direction: row;
			width: 100%;
			margin: 0 0;
			padding-top: var(--header-height);
		}

		.settings {
			position: relative;
			display: block;
			width: 0;
			opacity: 0;
			flex-shrink: 0;
			margin-left: var(--padding);

			transition: width 0.4s ease-out, opacity 0.4s ease-out;
			overflow-y: scroll;
			overflow-x: hidden;
		}
		.settings.active {
			width: 350px;
			opacity: 1;
		}
		.panel {
			width: 320px;
			margin-left: var(--padding);
		}

		.solarRecommendations {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
			overflow-y: scroll;
			padding-left: var(--padding);
		}
		button {
			position: fixed;
			z-index: 10;
			left: 0;
			top: 77px;
			background-color: var(--color-widget-background-light);
			color: var(--color-black);
			font: var(--font-widget-label);
			padding: 5px var(--padding);
			border: none;

			transform: rotateZ(90deg);
			transform-origin: bottom left;
			cursor: pointer;
		}
	`;

	@property({type: Boolean})
	showSettings = true;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.solar = state.solar.data;
		this.solarLuminarCount = selectSolarLuminarCountValue(state);
		this.translations = state.productData.translations;
	}
	toggleSettings() {
		this.showSettings = !this.showSettings;
	}
	render() {
		return html`
			<button @click=${this.toggleSettings}>${msg('Settings')}</button>

			<div class="settings ${classMap({active: this.showSettings})}">
				<div class="panel">
					<solar-settings-panel></solar-settings-panel>
				</div>
			</div>

			<div class="solarRecommendations">
				<solar-assembly title="XL ${msg('Solar unit')}" generators="4"></solar-assembly>
				<solar-assembly title="L ${msg('Solar unit')}" generators="3"></solar-assembly>
				<solar-assembly title="M ${msg('Solar unit')}" generators="2"></solar-assembly>
				${when(this.solarLuminarCount === 1, () => html`
					<solar-assembly title="S ${msg('Solar unit')}" generators="1"></solar-assembly>
				`)}
			</div>
        `;

	}
}
